import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsDashboard = ({ metrics }) => {
  return (
    <div className="bg-gradient-brand rounded-2xl p-8 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-64 h-64 bg-primary rounded-full -translate-y-32 translate-x-32" />
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-primary rounded-full translate-y-24 -translate-x-24" />
      </div>
      {/* Content */}
      <div className="relative z-10">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center space-x-3 mb-4">
            <div className="p-3 bg-primary/20 rounded-xl">
              <Icon name="BarChart3" size={32} className="text-primary" />
            </div>
            <h2 className="text-3xl font-brand-headline">
              Portfolio Impact
            </h2>
          </div>
          <p className="text-white/80 font-brand-body max-w-2xl mx-auto">
            Measurable results from delivering exceptional React and React Native with other Technologies solutions across diverse industries and project scales.
          </p>
        </div>

        {/* Metrics Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {metrics?.map((metric, index) => (
            <div
              key={index}
              className="text-center p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20 hover:bg-white/15 transition-all duration-300 group"
            >
              <div className="mb-4">
                <Icon 
                  name={metric?.icon} 
                  size={32} 
                  className="text-primary mx-auto group-hover:scale-110 transition-transform duration-300" 
                />
              </div>
              <div className="text-3xl font-brand-headline text-primary mb-2">
                {metric?.value}
              </div>
              <div className="text-white/90 font-brand-medium text-sm mb-1">
                {metric?.label}
              </div>
              <div className="text-white/70 font-brand-body text-xs">
                {metric?.description}
              </div>
            </div>
          ))}
        </div>

        {/* Additional Stats */}
        <div className="mt-8 pt-8 border-t border-white/20">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            <div>
              <div className="text-2xl font-brand-headline text-primary mb-1">
                100%
              </div>
              <div className="text-white/90 font-brand-medium text-sm">
                Client Satisfaction Rate
              </div>
            </div>
            <div>
              <div className="text-2xl font-brand-headline text-primary mb-1">
                24/7
              </div>
              <div className="text-white/90 font-brand-medium text-sm">
                Support & Maintenance
              </div>
            </div>
            <div>
              <div className="text-2xl font-brand-headline text-primary mb-1">
                &lt;48h
              </div>
              <div className="text-white/90 font-brand-medium text-sm">
                Average Response Time
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetricsDashboard;